import React from 'react';
import { Dropdown } from 'semantic-ui-react';
import { useUpdateOwnership } from '~/mutations/admin/useUpdateOwnership';
import { useUpdateCompanyOwnership } from '~/mutations/admin/useUpdateCompanyOwnership';
import { CompanyOwnershipDisplay } from '~/constants/company-ownership';
import './styles.scss';

interface OwnershipDropdownProps {
  typeDisplay?: string;
  ownershipText: string;
  defaultValue: string;
  buttonText: string;
  options: { key: string; text: string; value: string }[];
  onChange: (e: React.SyntheticEvent<HTMLElement>, value: string) => void;
}

const OwnershipDropdown: React.FC<OwnershipDropdownProps> = ({
  typeDisplay,
  ownershipText,
  defaultValue,
  buttonText,
  options,
  onChange,
}) => {
  const { status: updateOwnershipStatus } = useUpdateOwnership();
  const { status: updateCompanyOwnershipStatus } = useUpdateCompanyOwnership();

  const isDisabled = updateOwnershipStatus === 'loading' || updateCompanyOwnershipStatus === 'loading';

  return (
    <div>
      <span className="ownership-text">
        {ownershipText === CompanyOwnershipDisplay.OWNER ? `${typeDisplay} ${ownershipText}: ` : `${ownershipText}: `}
      </span>
      <Dropdown
        defaultValue={defaultValue}
        disabled={isDisabled}
        trigger={
          <button className="ownership-dropdown-button">
            {buttonText}
          </button>
        }
        options={options}
        onChange={(e, data) => onChange(e, data.value as string)}
      />
    </div>
  );
};

export default OwnershipDropdown;